'use client';

import { createSlice } from '@reduxjs/toolkit';
import constants from '../../constants';

const initialState = {
	guarantee: {
		listDetail: [],
		acC_ID: '',
		cusT_NUMBER: '',
		currency: '',
		documenT_NO: '',
		documenT_DT: '',
		starT_DATE: '',
		paymenT_GUARANTEE: 0,
		guaranteE_HDR_ID: '',
	},
	guaranteeDetails: [],
	guaranteeSummary: {
		acc_id: '',
		cust_name_decrypt: '',
		cust_number: '',
		payment_guarantee_available_idr: 0,
		payment_guarantee_available_usd: 0,
		payment_guarantee_gap_idr: 0,
		payment_guarantee_gap_usd: 0,
		payment_guarantee_startdate_idr: '',
		payment_guarantee_startdate_usd: '',
		payment_guarantee_terms_idr: 0,
		payment_guarantee_terms_usd: 0,
	},
	customer: {
		...constants.defaultResponse,
	},
	identity: {
		sor: '',
		area: '',
		area_code: '',
		cust_number: '',
		cust_name: '',
		cm: '',
		status: '',
		website: null,
	},
	identify: {
		acc_id: '',
		sor: '',
		area: '',
		area_code: '',
		cust_number: '',
		cust_name_decrypt: '',
		cm: '',
		status: '',
		cust_type: '',
		sector: '',
		description: '',
		tax_identifier_decrypt: '',
		email_decrypt: '',
		website: '',
		bussiness_group: '',
		gas_source: '',
		industry_sector: '',
		start_Date: null,
		end_DAte: null,
		group_book: '',
		cust_group: '',
		personal_identifier: '',
		addr_bill_to_decrypt: '',
		addr_premise_decrypt: '',
		city: '',
		district: '',
		sub_district: '',
		price_code: '',
		min_contract: null,
		max_contract: null,
		contact_person_decrypt: '',
		home_phone_decrypt: '',
		mobile_phone_decrypt: '',
		corporate_flag: '',
		product_name: '',
		notifikasiLastSeen: {
			menu: {
				subscription: '',
				serviceRequest: '',
				amendment: '',
				promo: ''
			},
			customerNumber: null,
			userID: null
		}
	},
	contacts: {
		...constants.defaultResponse,
	},
	products: {
		...constants.defaultResponse,
	},
	invoices: {
		...constants.defaultResponse,
	},
	agreement: {
		...constants.defaultResponse,
	},
};

export const customerList = createSlice({
	name: 'customerList',
	initialState,
	reducers: {
		addCustomerList: (state, action) => {
			state.customer = action.payload;
		},
		changeIdentity: (state, action) => {
			state.identity = action.payload;
		},
		changeIdentify: (state, action) => {
			state.identify = action.payload;
		},
		changeContacts: (state, action) => {
			state.contacts = action.payload;
		},
		changeProducts: (state, action) => {
			state.products = action.payload;
		},
		changeInvoices: (state, action) => {
			state.invoices = action.payload;
		},
		changeAgreement: (state, action) => {
			state.agreement = action.payload;
		},
		changeGuarantee: (state, action) => {
			state.guarantee = action.payload;
		},
		changeGuaranteeSummary: (state, action) => {
			state.guaranteeSummary = action.payload;
		},
		changeGuaranteeDetails: (state, action) => {
			state.guaranteeDetails = action.payload;
		},
	},
});

export const {
	addCustomerList,
	changeIdentify,
	changeContacts,
	changeInvoices,
	changeProducts,
	changeIdentity,
	changeAgreement,
	changeGuarantee,
	changeGuaranteeSummary,
	changeGuaranteeDetails,
} = customerList.actions;

export default customerList.reducer;
